import { PropsWithChildren } from 'react'

export default function AlertCard(props: PropsWithChildren) {
  return (
    <div className='max-w-screen-md items-center rounded-2xl text-lg md:text-center z-10 py-2 p-4 md:py-8 md:px-16 border border-orange-200 shadow-xl shadow-orange-200/20 bg-gradient-to-r from-orange-50 to-stone-50 dark:from-stone-800 dark:to-stone-950'>
      {props.children}
    </div>
  )
}
